import { takeLatest, put, call, all } from "redux-saga/effects";

import { SEND_LEAVE_REQUEST } from "./actionType";

import { sendLeaveRequestSuccess, sendLeaveRequestFail } from "./action";

import { sendLeaveRequestApi } from "../../helpers/fakebackend_helper";

// send leave request

function* sendLeaveRequestSaga({ payload }) {
  try {
    const response = yield call(sendLeaveRequestApi, payload);
    yield put(sendLeaveRequestSuccess(response));
  } catch (error) {
    yield put(sendLeaveRequestFail(error));
  }
}

export function* watchSendLeaveRequestSaga() {
  yield takeLatest(SEND_LEAVE_REQUEST, sendLeaveRequestSaga);
}

export default function* LeaveRequest() {
  yield all([watchSendLeaveRequestSaga()]);
}
